import {Component, ElementRef, HostListener, ViewChild} from '@angular/core';
import {AppMenuComponent} from '../app.menu.component';

// Mismo menú (menu.opciones.ts y filtrado por roles) que Teki, con el markup de Avalon.
// En modo horizontal las secciones que no entran en una fila se agrupan en "Más".
@Component({
    selector: 'app-cbet-menu',
    template: `
        <ul #menuList class="layout-menu layout-main-menu clearfix">
            <li app-cbet-menuitem *ngFor="let item of model; let i = index;" [item]="item" [index]="i" [root]="true"></li>
        </ul>
    `,
    standalone: false
})
export class CbetMenuComponent extends AppMenuComponent {

    @ViewChild('menuList') menuList: ElementRef<HTMLUListElement>;

    // Espacio reservado para la opción "Más"
    private static readonly ANCHO_MAS = 110;

    private fullModel: any[];

    private anchos = new Map<any, number>();

    loadMenu() {
        super.loadMenu();
        if (this.model) {
            this.fullModel = this.model;
            this.anchos.clear();
            // se mide con todas las secciones pintadas y recién ahí se agrupa el sobrante
            setTimeout(() => this.reorganizar());
        }
    }

    @HostListener('window:resize')
    reorganizar() {
        if (!this.fullModel || !this.menuList) {
            return;
        }
        if (!(this.appMain?.isHorizontal() && this.appMain?.isDesktop())) {
            this.model = this.fullModel;
            return;
        }
        if (!this.medir()) {
            // aún no se pintaron todas: se pinta el menú completo y se vuelve a intentar
            this.model = this.fullModel;
            setTimeout(() => this.reorganizar());
            return;
        }

        const visibles = this.fullModel.filter(item => item.visible !== false);
        const disponible = this.menuList.nativeElement.clientWidth - 16;
        const total = visibles.reduce((suma, item) => suma + this.anchos.get(item), 0);
        if (total <= disponible) {
            this.model = this.fullModel;
            return;
        }

        const enFila = [];
        let usado = CbetMenuComponent.ANCHO_MAS;
        for (const item of visibles) {
            usado += this.anchos.get(item);
            if (usado > disponible) {
                break;
            }
            enFila.push(item);
        }
        const sobrantes = visibles.slice(enFila.length);
        this.model = [...enFila, {label: 'Más', icon: 'pi pi-fw pi-ellipsis-h', visible: true, items: sobrantes}];
    }

    // Guarda el ancho de cada sección visible; devuelve false si alguna aún no está en pantalla
    private medir(): boolean {
        const pendientes = this.fullModel.filter(item => item.visible !== false && !this.anchos.has(item));
        if (!pendientes.length) {
            return true;
        }
        if (this.model !== this.fullModel) {
            return false;
        }
        const lis = Array.from(this.menuList.nativeElement.children) as HTMLElement[];
        this.fullModel.forEach((item, i) => {
            const ancho = lis[i]?.getBoundingClientRect().width;
            if (item.visible !== false && ancho) {
                this.anchos.set(item, ancho);
            }
        });
        return this.fullModel.every(item => item.visible === false || this.anchos.has(item));
    }
}
